#global-modal-container .big-modal-overlay .big-modal-wrapper.model-edit-modal {
  padding: 0;
}

.model-edit-modal {
  display: flex;
  flex-direction: column;
  min-width: 800px;
  min-height: 300px;
  position: relative;
  justify-content: space-between;
  width: 100%;
}
.model-edit-modal .top-toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.5rem 1.5rem 1rem;
}
.model-edit-modal .top-toolbar .avt-react-components--icon {
  cursor: pointer;
}
.model-edit-modal .top-toolbar h2 {
  margin: 0;
  font-size: 1.2rem;
  flex: 1;
}
.model-edit-modal .model-edit-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: calc(100% - 1.5rem);
}
.model-edit-modal .model-edit-content:focus {
  outline: none;
}
.model-edit-modal .model-edit-content .model-viewer .avt-progress-bar {
  left: 75px;
}

.clear-mappings-modal {
  display: block;
  width: 35rem;
  min-width: auto;
  position: relative;
  bottom: auto;
  margin: auto;
}
.clear-mappings-modal .body {
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  line-height: normal;
}
.clear-mappings-modal .body > div:not(:last-child) {
  padding-bottom: 0.5rem;
}
.clear-mappings-modal .body > div:last-child {
  padding-top: 1.5rem;
}
.clear-mappings-modal .actions {
  display: flex;
  justify-content: space-between;
}

.dark-theme .model-edit-modal .top-toolbar {
  border-bottom: 1px solid rgb(15%, 15%, 15%);
}

.light-theme .model-edit-modal .top-toolbar {
  border-bottom: 1px solid rgb(90%, 90%, 90%);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */